import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog,
  Typography,
  Grid,
  TextField,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Radio,
  RadioGroup,
  ListItem,
  ListItemText,
  List,
  ListItemIcon,
  Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Tooltip } from '@material-ui/core';
import LanguageIcon from '@mui/icons-material/Language';
import DescriptionIcon from '@mui/icons-material/Description';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MapIcon from '@mui/icons-material/Map';
import ForestIcon from '@mui/icons-material/Forest';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { requiredCertificationInformationDropDownOption, requiredDropDownFields } from '../Data/ConvertToContractIpFields';
import { initialExtractionRatesData, ExtractionInputFileds, uomOptions, emailOptions } from '../Data/ExtractionRatesFields';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDropzone } from 'react-dropzone';
import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';
const INITIAL_CRETIFICATION_INFO = {
  contractUniqueID: '',
  forestSourcingArea: '',
  supplierType: '',
  validSelfDeclaration: '',
  biomassSite: '',
  forestGrower: '',
  contractWith: '',
  harvestedBy: '',
  tripartiteAgreement: '',
  notes: '',
};
const DEFAULT_CONVERSION_FACTOR = 1.15;
const DropzoneUpload = ({ label, onFileSelect, multiple = false, required = false }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple,
    onDrop: acceptedFiles => {
      const files = multiple ? acceptedFiles : [acceptedFiles[0]];
      setSelectedFiles(files);
      if (onFileSelect) {
        onFileSelect(multiple ? files : files[0]);
      }
    },
  });

  return (
    <Box
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        '& .MuiTypography-root': {
          fontSize: '0.825rem !important',
        },
      }}>
      <Typography variant="subtitle1" gutterBottom>
        {label}{' '}
        {required && (
          <Typography component="span" color="error">
            *
          </Typography>
        )}
      </Typography>

      {selectedFiles.length > 0 && (
        <Box
          mt={1}
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 1,
            py: 1,
            px: 0.5,
          }}>
          {selectedFiles.map((file, index) => (
            <Tooltip title={file.name}>
              <Chip
                key={index}
                label={file.name.length > 20 ? file.name.slice(0, 18) + '…' : file.name}
                color="primary" // red primary color
                sx={{
                  fontSize: '0.7rem', // Slightly bigger text
                  height: '24px',
                  px: 1,
                }}
              />
            </Tooltip>
          ))}
        </Box>
      )}
      <Paper
        {...getRootProps()}
        elevation={0}
        sx={{
          border: '2px dashed #ccc',
          backgroundColor: isDragActive ? '#f0faff' : 'transparent',
          p: 3,
          textAlign: 'center',
          cursor: 'pointer',
          minHeight: selectedFiles.length > 0 ? 140 : 170,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <input required={required} {...getInputProps()} />
        <CloudUploadIcon sx={{ fontSize: 40, mb: 1, color: 'gray', mx: 'auto' }} />
        <Typography variant="body1" fontWeight="bold">
          Browse Files
        </Typography>
        <Typography variant="body2" color="text.secondary">
          or drag and drop files here
        </Typography>
      </Paper>
    </Box>
  );
};
const ConvertToContractModal = ({ open, setOpen, selectedSite, handleContractConfirmDialog, handleContractSubmit }) => {
  const [selectedSiteData, setSelectedSiteData] = useState({});

  const [requiredCertificationInformation, setRequiredCertificationInfo] = useState(INITIAL_CRETIFICATION_INFO);
  const [extractionRates, setExtractionRates] = useState(initialExtractionRatesData);
  const [conversionFactor, setConversionFactor] = useState(DEFAULT_CONVERSION_FACTOR);
  const [notes, setNotes] = useState({
    office: '',
    operator: '',
  });
  const [files, setFiles] = useState({
    office: null,
    operator: null,
  });
  const [emailList, setEmailList] = useState({
    requestor: '',
    contract: '',
  });
  const [isFormReadForContractGeneration, setIsFormReadyForContractGeneration] = useState(true);

  useEffect(() => {
    setSelectedSiteData(selectedSite);
  }, [selectedSite]);
  const handleClose = () => {
    setOpen(false);
  };
  const handleEmailChange = (key, value) => {
    setEmailList({ ...emailList, [key]: value });
  };
  const handleRequiredCertificationInfoChange = (key, value) => {
    setRequiredCertificationInfo(prev => ({ ...prev, [key]: value }));
  };
  const handleSiteDataChange = (key, value) => {
    setSelectedSiteData(prev => ({ ...prev, [key]: value }));
  };
  const handleExtractionDataChange = (key, value) => {
    setExtractionRates(prev => ({ ...prev, [key]: value }));
  };
  const handleFileChange = key => file => {
    setFiles(prev => ({
      ...prev,
      [key]: file,
    }));
  };
  const handleIsContractReadyChange = event => {
    setIsFormReadyForContractGeneration(event.target.value === 'Yes');
  };
  const submitContract = () => {
    console.log('contract submitted');
    const todaysDate = toLocalISO();
    const addContractData = {
      crmID: selectedSiteData.crmID,
      submissionDate: todaysDate,
      lastUpdateDate: todaysDate,
      contractUniqueID: null,
      siteAssessmentCompleted: 'Yes', //to check
      wH_NumberName: selectedSiteData.wH_Number,
      siteAssessmentID: selectedSiteData.siteAssessmentID,
      supplierSPDescription: selectedSiteData.ownerName,
      fellingLicenseNo: selectedSite.licenseNo, //to check
      projectDescriptionUsedonMachines: null, //to check
      contractType: null, //to check
      emailForLogwatchAccess: null, //to check
      subContractType: null, //to check
      purchaseType: null, //to check
      completeProductDetails: null, //check
      startDate: null, //to check
      finishDate: null, //to check
      supplier: null, //to check
      landOwnerDetails: selectedSiteData.ownerName, //to check
      customerName: null, //to check
      address: selectedSiteData.address1,
      address2: '',
      city: selectedSiteData.address2, //to check
      postCode: '', //to check
      via: '', //to check
      willanyProductsBePurchased: null, //to check
      requiredDocumentsForOnlineDocket: null, //to check
      isPulpStakesHarvestedforCoillte: null, //to check
      harvestPlanLink: selectedSiteData.harvestPlanLink,
      notestoOffice: notes.office,
      notestoOperators: notes.operator,
      authorisedOperators: null, //to check
      isFormReadyforContractGeneration: isFormReadForContractGeneration ? 'Yes' : 'No',
      notifyOperatorEmail1: selectedSiteData.operatorEmail1, //to check
      notifyOperatorEmail2: selectedSiteData.operatorEmail2,
      notifyOperatorEmail3: selectedSiteData.operatorEmail3,
      requestorEmailAddress: emailList.requestor,
      confirmationEmails: emailList.contract,
      harvestingEmailsForSiteDetails: null, //to check
    };

    const certificationInfo = { ...requiredCertificationInformation };
    const addContractCoillte = {
      harvestingRate: extractionRates.harvestingRate,
      harvestingMeasurementType: null,
      harvestingAssest: null,
      forwardingRate: extractionRates.forwardingRate,
      forwardingMeasurementType: null,
      forwardingAssest: null,
      coillteRoadsideRate: 0,
      shortStakesPremium: 0,
      coillteRateConfirmedBy: null,
    };
    const addContractInvoicingRates = { ...extractionRates };

    const addContractProductDetails = {
      contractUniqueID: null,
      productGroup: null,
      purchasePrice: 0,
      productSource: null,
      estimatedQty: 0,
      destination: null,
    };
    const addContractRates = {
      contractUniqueID: null,
      harvestingRate: extractionRates.harvestingRate,
      harvestingMeasurementType: null,
      harvestingAssest: null,
      harvestExtractingRate: 0,
      harvestExtractingMeasurementType: null,
      harvestExtractingAssest: null,
      extractionRate: 0,
      extractionMeasurementType: null,
      extractionAssest: null,
      haulage: 0,
      chipping: 0,
    };
    handleContractSubmit(
      addContractData,
      certificationInfo,
      addContractCoillte,
      addContractInvoicingRates,
      addContractProductDetails,
      addContractRates,
      files,
    );
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    console.log('form submitted');
    handleContractConfirmDialog('Do you wish to proceed with creating the contract?', submitContract, null);
  };

  return (
    <Dialog fullWidth maxWidth="lg" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Convert To Contract
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}>
        <CloseIcon />
      </IconButton>
      <form
        onSubmit={handleFormSubmit}
        onKeyDown={e => {
          if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
          }
        }}>
        <DialogContent
          dividers
          sx={{
            height: '75vh', // limit modal content height to 60% viewport height
            overflowY: 'auto',
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              '& .MuiAutocomplete-option': {
                fontSize: '0.75rem !important', // Change font size
                color: 'blue', // Optional: Change text color
              },
            }}>
            <Box
              sx={{
                backgroundColor: 'rgb(236 236 236)',
                borderRadius: '0.5rem',
                padding: '8px 16px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '12px',
                fontSize: '14px',
              }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, mr: 2, lineHeight: 1 }}>
                Links:
              </Typography>
              <Tooltip title="List of Contracts">
                <IconButton href="/siteContracts" size="small" target="_blank">
                  <DescriptionIcon color="primary" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Logwatch">
                <IconButton href="https://app.log-watch.com/Home/Index" size="small" target="_blank">
                  <VisibilityIcon color="primary" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Planner">
                <IconButton
                  href="https://tasks.office.com/worrellharvesting.ie/en-GB/Home/Planner"
                  size="small"
                  target="_blank">
                  <EventNoteIcon color="primary" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Maps">
                <IconButton href="https://www.google.com/maps" target="_blank" rel="noopener" size="small">
                  <MapIcon color="primary" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Forestry Viewer">
                <IconButton href="https://flv.apps.services.agriculture.gov.ie/" size="small" target="_blank">
                  <ForestIcon color="primary" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Control Panel">
                <IconButton href="/dashboard-page" size="small" target="_blank">
                  <SettingsIcon color="primary" />
                </IconButton>
              </Tooltip>
            </Box>
            <Box sx={{ padding: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <InputLabel
                    size="small"
                    required
                    sx={{
                      paddingBottom: '10px',
                      fontSize: '0.85rem',
                      color: 'black',
                    }}>
                    Site Assessment Reference
                  </InputLabel>
                  <TextField
                    size="small"
                    placeholder="Selected Site Assessment Reference"
                    required
                    fullWidth
                    variant="outlined"
                    helperText="selected site assessment ID"
                    InputLabelProps={{ shrink: true }}
                    value={selectedSiteData.siteAssessmentID}
                    name="siteAssessmentId"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputLabel
                    size="small"
                    required
                    sx={{
                      paddingBottom: '10px',
                      fontSize: '0.85rem',
                      color: 'black',
                    }}>
                    Felling Licence No
                  </InputLabel>
                  <TextField
                    size="small"
                    placeholder="Enter Licence No"
                    required
                    fullWidth
                    variant="outlined"
                    helperText="For an SP to be considered sustainable it must have a Felling Licence"
                    InputLabelProps={{ shrink: true }}
                    value={selectedSiteData.licenseNo}
                    onChange={e => handleSiteDataChange('licenseNo', e.target.value)}
                    name="siteAssessmentLicence"
                  />
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Accordion
                sx={{
                  border: '1px solid #e2e2e2',
                  boxShadow: '0px 5px 8px rgba(0, 0, 0, 0.1)', // subtle shadow
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  '&::before': {
                    display: 'none', // removes default MUI divider line
                  },
                  '&.Mui-expanded': {
                    margin: 0,
                  },
                  fontSize: '0.85rem',
                }}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1-content"
                  id="requiredCertificationInformation">
                  <Typography sx={{ fontSize: '0.9rem' }} component="span">
                    Required Certification Information *{' '}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      '& .MuiTableCell-root': {
                        fontSize: '0.825rem',
                      },
                      '& .MuiInputBase-root': {
                        fontSize: '0.825rem !important',
                      },
                    }}>
                    {requiredDropDownFields.map((inputProps, index) => (
                      <Grid item xs={12} sm={6} md={inputProps.width || 4} key={`${inputProps.name}_${index}`}>
                        <InputLabel
                          size="small"
                          sx={{
                            paddingBottom: '10px',
                            fontSize: '0.825rem',
                            color: 'black',
                          }}>
                          {inputProps.label}
                        </InputLabel>
                        {inputProps.typeOfInp == 'select' && (
                          <Autocomplete
                            size="small"
                            disablePortal
                            options={requiredCertificationInformationDropDownOption[inputProps.name] || []}
                            value={requiredCertificationInformation[inputProps.name] || null}
                            onChange={(event, newValue) =>
                              handleRequiredCertificationInfoChange(inputProps.name, newValue || '')
                            }
                            sx={{ fontSize: '0.8rem' }}
                            renderInput={params => <TextField {...params} required size="small" fullWidth />}
                            fullWidth
                          />
                        )}
                        {inputProps.typeOfInp == 'input' && (
                          <TextField
                            size="small"
                            variant="outlined"
                            type={inputProps.textFieldType || 'text'}
                            fullWidth
                            value={requiredCertificationInformation[inputProps.name] ?? ''}
                            onChange={e => handleRequiredCertificationInfoChange(inputProps.name, e.target.value)}
                            multiline={inputProps.isTextArea}
                            name={inputProps.name}
                          />
                        )}

                        {/* </FormControl> */}
                      </Grid>
                    ))}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box>
              <Accordion
                sx={{
                  border: '1px solid #e2e2e2',
                  boxShadow: '0px 5px 8px rgba(0, 0, 0, 0.1)', // subtle shadow
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  '&::before': {
                    display: 'none', // removes default MUI divider line
                  },
                  '&.Mui-expanded': {
                    margin: 0,
                  },
                  fontSize: '0.825rem',
                }}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1-content"
                  id="requiredCertificationInformation">
                  <Typography sx={{ fontSize: '0.9rem' }} component="span">
                    Extraction Rates - Used to invoice customers and set Operational Targets (add email *)
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={1}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        '& .MuiTableCell-root': {
                          fontSize: '0.825rem',
                        },
                        '& .MuiInputBase-root': {
                          fontSize: '0.825rem !important',
                        },
                      }}>
                      <Table>
                        <TableHead>
                          <TableRow sx={{ fontSize: '0.8rem' }}>
                            <TableCell />
                            <TableCell>€</TableCell>
                            <TableCell width="15%">UOM</TableCell>
                            <TableCell>Note</TableCell>
                            <TableCell>Confirmed by</TableCell>
                            <TableCell width="15%">Send Email</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ExtractionInputFileds.map(row => (
                            <TableRow key={row.label}>
                              <TableCell>{row.label}</TableCell>
                              {/* Rate */}
                              <TableCell>
                                <TextField
                                  type="number"
                                  fullWidth
                                  size="small"
                                  required
                                  value={extractionRates[row.fields.rate]}
                                  onChange={e => handleExtractionDataChange(row.fields.rate, e.target.value)}
                                  name={row.fields.rate}
                                />
                              </TableCell>
                              {/* UOM */}
                              <TableCell>
                                <Autocomplete
                                  options={uomOptions}
                                  value={extractionRates[row.fields.uom] || null}
                                  onChange={(event, newValue) => handleExtractionDataChange(row.fields.uom, newValue || '')}
                                  renderInput={params => (
                                    <TextField {...params} size="small" required placeholder="Select..." />
                                  )}
                                  sx={{
                                    fontSize: '0.8rem',
                                  }}
                                  slotProps={{
                                    paper: {
                                      sx: {
                                        '& .MuiAutocomplete-option': {
                                          fontSize: '0.75rem',
                                          color: 'primary.main',
                                          fontWeight: 500,
                                        },
                                      },
                                    },
                                  }}
                                  disableClearable
                                  fullWidth
                                />
                              </TableCell>
                              {/* Note */}
                              <TableCell>
                                <TextField
                                  fullWidth
                                  size="small"
                                  required
                                  value={extractionRates[row.fields.note]}
                                  onChange={e => handleExtractionDataChange(row.fields.note, e.target.value)}
                                  name={row.fields.note}
                                />
                              </TableCell>
                              {/* Confirmed By */}
                              <TableCell>
                                <TextField
                                  fullWidth
                                  size="small"
                                  required
                                  value={extractionRates[row.fields.confirmedBy]}
                                  onChange={e => handleExtractionDataChange(row.fields.confirmedBy, e.target.value)}
                                  name={row.fields.confirmedBy}
                                />
                              </TableCell>
                              {/* Email */}
                              <TableCell>
                                <Autocomplete
                                  options={emailOptions}
                                  value={extractionRates[row.fields.email] || null}
                                  renderInput={params => (
                                    <TextField {...params} size="small" required placeholder="Select..." />
                                  )}
                                  onChange={(event, newValue) =>
                                    handleExtractionDataChange(row.fields.email, newValue || '')
                                  }
                                  slotProps={{
                                    paper: {
                                      sx: {
                                        '& .MuiAutocomplete-option': {
                                          fontSize: '0.75rem',
                                          color: 'primary.main',
                                          fontWeight: 500,
                                        },
                                      },
                                    },
                                  }}
                                  sx={{
                                    fontSize: '0.8rem',
                                  }}
                                  disableClearable
                                  fullWidth
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box sx={{ padding: 1 }}>
              <Accordion
                sx={{
                  border: '1px solid #e2e2e2',
                  boxShadow: '0px 5px 8px rgba(0, 0, 0, 0.1)', // subtle shadow
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  '&::before': {
                    display: 'none', // removes default MUI divider line
                  },
                  '&.Mui-expanded': {
                    margin: 0,
                  },
                  fontSize: '0.825rem',
                }}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1-content"
                  id="uploadContractFileAndEmail">
                  <Typography sx={{ fontSize: '0.9rem' }} component="span">
                    Upload Contract Files and Email
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <InputLabel
                        size="small"
                        required
                        sx={{
                          paddingBottom: '10px',
                          fontSize: '0.85rem',
                          color: 'black',
                        }}>
                        Conversion Factor
                      </InputLabel>
                      <TextField
                        size="small"
                        placeholder="Conversion Factor"
                        required
                        fullWidth
                        variant="outlined"
                        helperText="Default 1.15 but Important to adjust for windblow lighter timber"
                        InputLabelProps={{ shrink: true }}
                        value={conversionFactor}
                        onBlur={e => setConversionFactor(e.target.value)}
                        name="conversionFactor"
                      />
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      flexGrow: 1,
                      paddingTop: '1rem',
                      '& .MuiTypography-root': {
                        fontSize: '0.825rem !important',
                      },
                    }}>
                    <Grid container spacing={4}>
                      {/* Upload for Office */}
                      <Grid item xs={12} md={6}>
                        <DropzoneUpload
                          label="Upload Contract and Relevant Documents for Office"
                          required
                          onFileSelect={handleFileChange('office')}
                          multiple={true}
                        />
                      </Grid>

                      {/* Notes to Office */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle1" gutterBottom>
                          Notes to Office
                        </Typography>
                        <TextField
                          multiline
                          minRows={6}
                          fullWidth
                          placeholder="Type here..."
                          value={notes.office}
                          onChange={e => setNotes({ ...notes, office: e.target.value })}
                          name="officeNotes"
                        />
                      </Grid>

                      {/* Upload for Operator */}
                      <Grid item xs={12} md={6}>
                        <DropzoneUpload
                          label="Upload Relevant Documents for Operator"
                          onFileSelect={handleFileChange('operator')}
                          multiple={true}
                        />
                      </Grid>

                      {/* Notes to Operator */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle1" gutterBottom>
                          Notes to Operators
                        </Typography>
                        <TextField
                          multiline
                          minRows={6}
                          fullWidth
                          placeholder="Type here..."
                          value={notes.operator}
                          onChange={e => setNotes({ ...notes, operator: e.target.value })}
                          name="operatorNotes"
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ padding: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <InputLabel
                          size="small"
                          required
                          sx={{
                            paddingBottom: '10px',
                            fontSize: '0.85rem',
                            color: 'black',
                          }}>
                          Is this Form ready for Contract Generation
                        </InputLabel>
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'start', alignItems: 'center' }}>
                          <InputLabel style={{ marginBottom: 0 }}>Yes</InputLabel>
                          <Radio
                            checked={isFormReadForContractGeneration === true}
                            onChange={handleIsContractReadyChange}
                            label="YES"
                            value="Yes"
                            name="isFormReadyForContractGenreation"
                            slotprops={{ input: { 'aria-label': 'Yes' } }}
                          />
                          <InputLabel style={{ marginBottom: 0 }}>No</InputLabel>

                          <Radio
                            label="NO"
                            checked={isFormReadForContractGeneration === false}
                            onChange={handleIsContractReadyChange}
                            value="No"
                            name="isFormReadyForContractGenreation"
                            slotprops={{ input: { 'aria-label': 'No' } }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={12} sx={{ paddingTop: '1rem' }}>
                        <InputLabel
                          size="small"
                          required
                          sx={{
                            paddingBottom: '10px',
                            fontSize: '0.85rem',
                            color: 'black',
                          }}>
                          Contract emails for Price Confirmation
                        </InputLabel>
                        <TextField
                          size="small"
                          placeholder="Contract emails for Price Confirmation "
                          required
                          fullWidth
                          variant="outlined"
                          helperText="Put a ; between each email address to seperate "
                          InputLabelProps={{ shrink: true }}
                          defaultValue=""
                          name="contractEmails"
                          onBlur={e => {
                            handleEmailChange('contract', e.target.value);
                          }}
                        />
                      </Grid>

                      {isFormReadForContractGeneration && (
                        <Grid item xs={12} md={12}>
                          <InputLabel
                            size="small"
                            required
                            sx={{
                              paddingBottom: '10px',
                              fontSize: '0.85rem',
                              color: 'black',
                            }}>
                            Requestor emails for relevant site details notification
                          </InputLabel>
                          <TextField
                            size="small"
                            placeholder="Requestor emails for relevant site details notification "
                            required
                            fullWidth
                            variant="outlined"
                            helperText="Put a ; between each email address to seperate "
                            InputLabelProps={{ shrink: true }}
                            defaultValue=""
                            name="requestorEmail"
                            onBlur={e => {
                              handleEmailChange('requestor', e.target.value);
                            }}

                            // value={selectedSiteData.licenseNo}
                            // onChange={e => handleSiteDataChange('licenseNo', e.target.value)}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit">
            Save Contract
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ConvertToContractModal;
